import ProtectedRoute from './ProtectedRoute';

function AdminRoute({ children }) {
  return (
    <ProtectedRoute requireAdmin={true}>
      {children}
    </ProtectedRoute>
  );
}

export default AdminRoute;
